// import { useNavigate } from 'react-router-dom';
import { ArrowRight, BookOpen, Users, Target } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
// import { useAnalytics } from '@/hooks/useAnalytics';

const InternalLinksSection = () => {
  // const navigate = useNavigate();
  // const { trackCTAClick } = useAnalytics();

  const contentLinks = [
    {
      title: "What is PACT Framework?",
      description: "Learn the minimalist approach to building habits without overthinking",
      path: "/what-is-pact-framework",
      icon: BookOpen,
      color: "bg-purple-100 text-purple-600"
    },
    {
      title: "Why Most Habit Apps Fail",
      description: "Discover why complexity is the enemy of consistency",
      path: "/why-habit-apps-fail",
      icon: Target,
      color: "bg-yellow-100 text-yellow-600",
      comingSoon: true
    },
    {
      title: "Join Our Community",
      description: "Connect with 67+ people who show up again every day",
      path: "/early-access",
      icon: Users,
      color: "bg-green-100 text-green-600"
    }
  ];

  const handleLinkClick = (path: string, title: string) => {
    // trackCTAClick(`internal-link-${title.toLowerCase().replace(/\s+/g, '-')}`);
    // navigate(path);
    window.location.href = path;
  };

  return (
    <section className="container max-w-6xl mx-auto px-4 py-24">
      <div className="text-center mb-16">
        <h2 className="text-4xl md:text-5xl font-black text-white mb-4 tracking-tight">
          Learn More About
          <span className="block text-yellow-400">Showing Up Again</span>
        </h2>
        <p className="text-xl text-white/80 max-w-2xl mx-auto">
          Dive deeper into the philosophy and framework behind the app that comes before habits & goals.
        </p>
      </div>
      
      <div className="grid md:grid-cols-3 gap-8">
        {contentLinks.map((link, index) => {
          const Icon = link.icon;
          return (
            <Card 
              key={index} 
              className="bg-white/10 backdrop-blur-sm border-white/20 hover:bg-white/15 transition-all duration-300 cursor-pointer group"
              onClick={() => !link.comingSoon && handleLinkClick(link.path, link.title)}
            >
              <CardContent className="p-8 text-center">
                <div className={`w-16 h-16 ${link.color} rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300`}>
                  <Icon className="w-8 h-8" />
                </div>
                <h3 className="text-2xl font-bold text-white mb-4">{link.title}</h3>
                <p className="text-white/80 leading-relaxed mb-6">{link.description}</p>
                
                {link.comingSoon ? (
                  <span className="inline-flex items-center gap-2 text-yellow-400 font-semibold">
                    Coming Soon
                  </span>
                ) : (
                  <div className="inline-flex items-center gap-2 text-yellow-400 font-semibold group-hover:gap-4 transition-all duration-300">
                    Learn More
                    <ArrowRight className="w-4 h-4" />
                  </div>
                )}
              </CardContent>
            </Card>
          );
        })}
      </div>
    </section>
  );
};

export default InternalLinksSection;